import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { mapSearchParamsToFilters } from '~/shared/lib/utils'
import { FileExportBlob } from '~/shared/ui/FileExport'

type BalanceHistoryExportProps = {
  defaultFilters?: Record<string, string>
  exportFn: (search: string) => Promise<Blob>
}

export const BalanceHistoryExport = ({
  defaultFilters,
  exportFn,
}: BalanceHistoryExportProps) => {
  const [searchParams] = useSearchParams()

  const filters = useMemo(
    () => ({
      ...mapSearchParamsToFilters(searchParams),
      ...defaultFilters,
    }),
    [defaultFilters, searchParams],
  )

  const isFiltersValid = useMemo(
    () => filters.appliedAtTo && filters.appliedAtFrom,
    [filters.appliedAtFrom, filters.appliedAtTo],
  )

  const errorMessageFn = useCallback(() => {
    snackbarEnqueued({
      messageI18n: 'alert.set start and end date in filter',
      variant: 'error',
    })
  }, [])

  const handleExportFn = async () =>
    exportFn(new URLSearchParams(filters).toString())

  return (
    <FileExportBlob
      titleI18n='button.export to excel'
      fn={isFiltersValid ? handleExportFn : errorMessageFn}
    />
  )
}
